<script setup>
import { useCalculationStore } from '@/stores/calculation'
import { useRoute } from 'vue-router/dist/vue-router'
import router from '@/router'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import {
  BERTH_TYPE,
  DESCRIPTION,
  MOORING_SIDE,
  NAME,
  SHIP_TYPE
} from '@/constants/calculationFieldConstants'

const route = useRoute()
const store = useCalculationStore()

const { selectedItems, fields } = storeToRefs(store)

const props = defineProps({
  order: { type: Number, required: true },
  item: { type: Object, required: true }
})

const berthType = computed(() => {
  if (!fields.value) {
    return ''
  }
  return fields.value[BERTH_TYPE].choices.find((choice) => choice.value === props.item[BERTH_TYPE])
    ?.display_name
})

const shipType = computed(() => {
  if (!fields.value) {
    return ''
  }
  return fields.value[SHIP_TYPE].choices.find((choice) => choice.value === props.item[SHIP_TYPE])
    ?.display_name
})

const mooringSide = computed(() => {
  if (!fields.value) {
    return ''
  }
  return fields.value[MOORING_SIDE].choices.find(
    (choice) => choice.value === props.item[MOORING_SIDE]
  )?.display_name
})

function navigateToCalculation(id) {
  router.push({
    name: 'calculation',
    params: { id: route.params.id, calculationId: id }
  })
}

const isSelected = computed({
  get: () => {
    return selectedItems.value?.includes(props.item) || false
  },
  set: (value) => {
    store.updateSelectedItems(value, [props.item])
  }
})

const emit = defineEmits(['duplicate', 'editItem', 'deleteItem'])
</script>
<template>
  <tr
    v-ripple
    style="cursor: pointer"
    @click="navigateToCalculation(item.id)"
    :class="{
      'selected-item': isSelected
    }"
  >
    <td>
      <v-checkbox
        color="primary"
        v-model="isSelected"
        density="compact"
        hide-details
        @click.stop=""
      ></v-checkbox>
    </td>
    <td class="text-center">{{ order }}</td>
    <td>
      {{ item[NAME] }}
    </td>
    <td>
      {{ berthType }}
    </td>
    <td>
      {{ shipType }}
    </td>
    <td>
      {{ mooringSide }}
    </td>
    <td>
      {{ item[DESCRIPTION] }}
    </td>
    <td class="text-center">
      <v-btn
        icon="mdi-pencil"
        @click.stop="emit('editItem', item)"
        size="32"
        variant="text"
      ></v-btn>
    </td>
  </tr>
</template>
